import { useEffect, useState } from "react";
import Image from "components/Elements/Image/Image";
import useInviewSettingsDelay from "../../helpers/useAnimateInview";
import { useContent } from "contexts/contentContext/contentContext";
import { useInView } from "react-intersection-observer";

import styles from "./styles.module.scss";
import generalStyles from "../../styles.module.scss";

export const SecondSection = () => {
  const { getHtmlByKey } = useContent();
  const [showSecondImage, setShowSecondImage] = useState(false);

  const { inviewSettings, getFullClassName } = useInviewSettingsDelay();

  const [firstTextRef, firstTextInview] = useInView(inviewSettings);
  const [secondTextRef, secondTextInview] = useInView(inviewSettings);
  const [imageRef, imageInview] = useInView(inviewSettings);

  useEffect(() => {
    if (imageInview) {
      setTimeout(() => {
        setShowSecondImage(true);
      }, 300);
    }
  }, [imageInview]);

  return (
    <section className={styles.section}>
      <div className={styles.lightSection} ref={firstTextRef}>
        <h3
          className={getFullClassName(
            generalStyles.titleDark,
            "end",
            firstTextInview
          )}
        >
          {getHtmlByKey("picker-section-2-title-first")}
        </h3>
        <p
          className={getFullClassName(
            generalStyles.textDark,
            "end",
            firstTextInview
          )}
        >
          {getHtmlByKey("picker-section-2-text-first")}
        </p>
      </div>
      <div className={styles.absoluteWrapper}>
        <div className={styles.imageContainer} ref={imageRef}>
          <Image
            name="picker/picker-gallery"
            ext="png"
            className={getFullClassName(styles.gallery, "start", imageInview)}
          />
          <Image
            name="picker/picker-collection"
            ext="png"
            className={getFullClassName(
              styles.collection,
              "appear",
              showSecondImage
            )}
          />
          <Image
            name="picker/picker-tags"
            ext="png"
            className={getFullClassName(
              styles.tags,
              "appear",
              secondTextInview
            )}
          />
        </div>
      </div>
      <div className={styles.darkSection} ref={secondTextRef}>
        <h3
          className={getFullClassName(
            generalStyles.titleLight,
            "end",
            secondTextInview
          )}
        >
          {getHtmlByKey("picker-section-2-title-second")}
        </h3>
        <p
          className={getFullClassName(
            generalStyles.textLight,
            "end",
            secondTextInview
          )}
        >
          {getHtmlByKey("picker-section-2-text-second")}
        </p>
      </div>
      <Image name="cloud" ext="png" className={styles.cloud} />
    </section>
  );
};

export default SecondSection;
